import { Directive, ElementRef, inject, Input, Renderer2, } from '@angular/core';
import { ColorUtils } from '../../../../core/utils/ColorUtils';

@Directive({
  selector: '[appContrastText]',
  standalone: true
})
export class ContrastTextDirective {

  @Input('appContrastText') set backgroundColor(color: string) {
    this._backgroundColor = color;

    if (this._backgroundColor) {
      this.updateContrast();
    }
  }
  @Input() lightColor: string = '#ffffff';
  @Input() darkColor: string = '#000000';
  @Input() elementRef = inject(ElementRef);

  private _backgroundColor: string;
  private readonly _renderer = inject(Renderer2);

  private updateContrast(): void {
    this._renderer.setStyle(
      this.elementRef.nativeElement,
      'color',
      ColorUtils.isLightColor(this._backgroundColor) ? this.darkColor : this.lightColor
    );
  }
}
